import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { useAuth } from '../auth/AuthContext';
import GitHubSettingsPanel from '../components/account/GitHubSettingsPanel';

const AccountSettingsPage = () => {
  const { user } = useAuth();

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Stack spacing={3}>
        <Box>
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 0.5 }}>
            <SettingsIcon color="primary" />
            <Typography variant="h4" sx={{ fontWeight: 800 }}>
              Account settings
            </Typography>
          </Stack>
          <Typography color="text.secondary">
            Manage profile and repo settings for {user?.email || 'your account'}.
          </Typography>
        </Box>

        <GitHubSettingsPanel />
      </Stack>
    </Container>
  );
};

export default AccountSettingsPage;
